export default [
  {
    formatType: 'currency',
    items: [
      {
        label: '$1',
        value: '1',
      },
      {
        label: '$1,000',
        value: '1000',
      },
      {
        label: '$5,000',
        value: '5000',
      },
      {
        label: '$10,000',
        value: '10000',
      },
      {
        label: '$25,000',
        value: '25000',
      },
      {
        label: '$50,000',
        value: '50000',
      },
      {
        label: '$100,000',
        value: '100000',
      },
    ],
    keys: [
      {
        format: 'number',
        key: 'deposit_minimum',
      },
    ],
    subType: 'number',
    title: 'Deposit amount',
    value: '{{0}}',
    viewType: 'select',
  },
  {
    formatType: 'number',
    items: [
      {
        label: '6 months',
        value: '6',
      },
      {
        label: '1 year',
        value: '12',
      },
      {
        label: '2 years',
        value: '24',
      },
      {
        label: '3 years',
        value: '36',
      },
      {
        label: '4 years',
        value: '48',
      },
      {
        label: '5 years',
        value: '60',
      },
    ],
    keys: [
      {
        format: 'number',
        key: 'length_of_term',
      },
    ],
    subType: 'number',
    title: 'Length of CD',
    value: '{{0}}',
    viewType: 'select',
  },
  {
    formatType: 'none',
    items: [
      {
        formatType: 'none',
        keys: [
          {
            format: 'text',
            key: 'attribute-1',
          },
        ],
        label: '4 stars & up',
        subType: 'text',
        value: '4',
        viewType: 'input',
      },
      {
        formatType: 'none',
        keys: [
          {
            format: 'text',
            key: 'attribute-1',
          },
        ],
        label: '3 stars & up',
        subType: 'text',
        value: '3',
        viewType: 'input',
      },
      {
        formatType: 'none',
        keys: [
          {
            format: 'string',
            key: 'attribute-2',
          },
        ],
        label: '2 stars & up',
        subType: 'text',
        value: '2',
        viewType: 'input',
      },
      {
        formatType: 'none',
        keys: [
          {
            format: 'string',
            key: 'attribute-3',
          },
        ],
        label: 'All',
        subType: 'text',
        value: '',
        viewType: 'input',
      },
    ],
    keys: [
      {
        format: 'text',
        key: 'min_ratings',
      },
    ],
    subType: 'text',
    title: 'NerdWallet Rating',
    value: '{{0}}',
    viewType: 'select',
  },
];
